/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

document.addEventListener('DOMContentLoaded', () => {
  const sizeChart = document.querySelector('[data-size-chart]');
  const target = document.querySelector('[data-size-chart-target]');

  if (sizeChart && target) {
    target.appendChild(sizeChart);
    sizeChart.hidden = false;
  }
});


  // Mute button logic
  document.addEventListener("DOMContentLoaded", function () {
    const toggleButtons = document.querySelectorAll('.video-mute-toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const videoId = button.dataset.videoId;
        const video = document.getElementById(videoId);
        
        if (!video) return;
        const isMuted = video.muted;
        video.muted = !isMuted;

        button.classList.toggle('is-muted', video.muted);
      });
    });
  });

  

    // PDP Desc Read more Logic
    document.addEventListener("DOMContentLoaded", function () {
    const readMore = document.getElementById("read-more");
    const readLess = document.getElementById("read-less");
    const truncated = document.getElementById("truncated-description");
    const full = document.getElementById("full-description");

    if (readMore && readLess && truncated && full) {
      readMore.addEventListener("click", function () {
        truncated.style.display = "none";
        full.style.display = "block";
      });

      readLess.addEventListener("click", function () {
        full.style.display = "none";
        truncated.style.display = "block";
      });
    }
  });


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


// ─── Klaviyo form "SshSNM" → redirect to confirmation page ───────────────────
(function () {
    var KLAVIYO_FORM_ID = 'SshSNM';
    var REDIRECT_URL    = '/pages/appointment-booked';
    var oneYear         = 365;
    var exp             = new Date();
    exp.setDate(exp.getDate() + oneYear);

    function setCookie(name, value) {
        document.cookie = name + '=' + encodeURIComponent(value) +
            '; expires=' + exp.toUTCString() + '; path=/';
    }

    // Capture field values the moment the submit button is clicked,
    // before Klaviyo clears the form on success.
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-testid="klaviyo-form-' + KLAVIYO_FORM_ID + '"] button[type="button"]');
        if (!btn) return;

        var form = btn.closest('[data-testid="klaviyo-form-' + KLAVIYO_FORM_ID + '"]');
        if (!form) return;

        var firstNameEl = form.querySelector('input[autocomplete="given-name"]');
        var lastNameEl  = form.querySelector('input[autocomplete="family-name"]');
        var emailEl     = form.querySelector('input[type="email"]');

        if (firstNameEl) setCookie('mm-klaviyo-fname', firstNameEl.value.trim());
        if (lastNameEl)  setCookie('mm-klaviyo-lname', lastNameEl.value.trim());
        if (emailEl)     setCookie('mm-klaviyo-email', emailEl.value.trim());
        setCookie('mm-form-source', 'klaviyo');
    }, true);

    // Redirect on successful Klaviyo form submission.
    window.addEventListener('klaviyoForms', function (e) {
        if (!e.detail || e.detail.formId !== KLAVIYO_FORM_ID) return;
        if (e.detail.type === 'submit' || e.detail.type === 'stepSubmit') {
            window.location.href = REDIRECT_URL;
        }
    });
})();
